"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.list.title': 'Onboarding Sessions',
    'onboarding.list.description': 'Manage onboarding processes for your team members.',
    'onboarding.list.records': 'Onboarding Records',
    'onboarding.list.empty': 'No onboarding sessions found',
};
